var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okDisabled: true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "emp.empEntranceManager.managerWorkNo"
                              ]
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.managerWorkNo,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "managerWorkNo", $$v)
                              },
                              expression: "queryParam.managerWorkNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.language["emp.empEntranceManager.status"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "list",
                              dictCode: "entrance_manager_status",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.queryParam.status,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "status", $$v)
                              },
                              expression: "queryParam.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "cmscol:managerInsert",
                  expression: "'cmscol:managerInsert'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.language["emp.cmscol.manager.title"]) +
                  "\n    "
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.isShowSetBtn ? _vm.columns : _vm.baseColumns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              scroll: { x: true }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _vm.isShowSetBtn
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "cmscol:managerSet",
                                  expression: "'cmscol:managerSet'"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleSetting(record)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["emp.cmscol.manager.set"])
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.isShowSetBtn
                        ? _c("a-divider", { attrs: { type: "vertical" } })
                        : _vm._e(),
                      record.status == "0"
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "cmscol:managerFreeze",
                                  expression: "'cmscol:managerFreeze'"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen(record, "1")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["sys.dict.status.freeze"])
                              )
                            ]
                          )
                        : _vm._e(),
                      record.status != "0"
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "cmscol:managerFreeze",
                                  expression: "'cmscol:managerFreeze'"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen(record, "0")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.thawButton"]))]
                          )
                        : _vm._e(),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "cmscol:managerDelete",
                              expression: "'cmscol:managerDelete'"
                            }
                          ],
                          attrs: {
                            title: _vm.language["common.deleteConfirmInfo"]
                          },
                          on: {
                            confirm: function() {
                              return _vm.remove(record)
                            }
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.language["common.delete"]))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }
              },
              {
                key: "legalperson",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: record.legalperson,
                          placement: "topLeft",
                          disabled: false
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              !text
                                ? ""
                                : text.length > 20
                                ? text.substr(0, 20) + "..."
                                : text
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "cmscol:managerInsert",
                  expression: "'cmscol:managerInsert'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd2 }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.language["emp.cmscol.approver.title"]) +
                  "\n    "
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns2,
              dataSource: _vm.dataSource2,
              pagination: _vm.ipagination2,
              loading: _vm.loading2,
              scroll: { x: true }
            },
            on: { change: _vm.handleTableChange2 },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      record.status == "0"
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "cmscol:managerFreeze",
                                  expression: "'cmscol:managerFreeze'"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen2(record, "1")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["sys.dict.status.freeze"])
                              )
                            ]
                          )
                        : _vm._e(),
                      record.status != "0"
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "cmscol:managerFreeze",
                                  expression: "'cmscol:managerFreeze'"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen2(record, "0")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.thawButton"]))]
                          )
                        : _vm._e(),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "cmscol:managerDelete",
                              expression: "'cmscol:managerDelete'"
                            }
                          ],
                          attrs: {
                            title: _vm.language["common.deleteConfirmInfo"]
                          },
                          on: {
                            confirm: function() {
                              return _vm.remove2(record)
                            }
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.language["common.delete"]))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("cms-col-manager-user-modal", {
        ref: "userModal",
        on: { ok: _vm.searchQuery }
      }),
      _c("cms-col-approver-user-modal", {
        ref: "userModal2",
        on: { ok: _vm.searchQuery }
      }),
      _c("cms-col-tbl-manager-legalperson-modal", {
        ref: "legalpersonModal",
        on: { ok: _vm.searchQuery }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }